module.exports = __webpack_public_path__ + "stabilized-bridge-cover-2.75d298c.png";